module.exports = __webpack_public_path__ + "img/sailorsuit.513011aa.gif";